const selectors = {
  chartRoot: '[data-garment-chart-modal]',
  tab: '[data-garment-chart-tab]',
  content: '[data-garment-chart-content]',
  mobileSelect: '[data-garment-tab-select]',
};

export default class GarmentChartModal {
  constructor(container = document) {
    this.container = container;
    this.init();
  }

  init() {
    const chartRoots = this.container.querySelectorAll(selectors.chartRoot);

    chartRoots.forEach(chartRoot => {
      if (chartRoot.dataset.initialized === 'true') {
        return;
      }

      chartRoot.dataset.initialized = 'true';
      this.bindChart(chartRoot);
    });
  }

  bindChart(chartRoot) {
    const tabs = Array.from(chartRoot.querySelectorAll(selectors.tab));
    const contents = Array.from(chartRoot.querySelectorAll(selectors.content));
    const mobileSelect = chartRoot.querySelector(selectors.mobileSelect);

    const activateTab = tabId => {
      tabs.forEach(tab => {
        const isActive = tab.dataset.garmentChartTab === tabId;
        tab.classList.toggle('button--black', isActive);
      });

      contents.forEach(content => {
        const isActive = content.dataset.garmentChartContent === tabId;
        content.classList.toggle('hidden', !isActive);
      });

      if (mobileSelect && mobileSelect.value !== tabId) {
        mobileSelect.value = tabId;
      }
    };

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        activateTab(tab.dataset.garmentChartTab);
      });
    });

    if (mobileSelect) {
      mobileSelect.addEventListener('change', event => {
        activateTab(event.target.value);
      });
    }

    activateTab('tab-1');
  }
}
